
import Forge from 'node-forge'

export default class AppUtils {

    static MOVIES_INDEX_LABLES = 'MOVIES_INDEX_LABLES';
    static MAIN_PAGE_INDEX_KEY = 'MAIN_PAGE_INDEX_KEY';
    static SUBSCRIBE_INDEX = 'SUBSCRIBE_INDEX';
    static REARCH_HISTORY = 'REARCH_HISTORY';
    static MATCH_SELECTED = 'MATCH_SELECTED';
    static MATCH_DETAIL_DATA = 'MATCH_DETAIL_DATA';
    static CUSTOM_CHANNELS = 'CUSTOM_CHANNELS';

    static MATCH_SELECTED_TYPE_INDEX = 'MATCH_SELECTED_TYPE_INDEX';
    static MATCH_SELECTED_TAB_INDEX = 'MATCH_SELECTED_TAB_INDEX';
    static MATCH_SELECT_TIMER = 'MATCH_SELECT_TIMER';


    /**
     * 比较两个版本，0为相同版本，1-需要更新
     * @param {string} a 服务器最新版本
     * @param {string} b 本地当前版本
     */
    static compareVersion(a, b) {
        //假定字符串的每节数都在5位以下
        function versionToNum(a) {
            a = a.toString();
            //也可以这样写 var c=a.split(/\./);
            var c = a.split('.');
            var num_place = ["", "0", "00", "000", "0000"], r = num_place.reverse();
            for (var i = 0; i < c.length; i++) {
                var len = c[i].length;
                c[i] = r[len] + c[i];
            }
            var res = c.join('');
            return res;
        }

        var _a = versionToNum(a), _b = versionToNum(b);
        if (_a === _b) return 0;
        if (_a > _b) return 1;
        if (_a < _b) return -1;
    }

    static processList(result, rowNum) {
        var arr = [];
        for (let i = 0; i < result.length; i++) {
            const el = result[i];
            var arr2;
            if (i % rowNum === 0) {
                arr2 = [];
                arr.push(arr2);
            } else {
                arr2 = arr[arr.length - 1];
            }
            arr2.push(el);
        }
        return arr;
    }

    /**
     * 将byte数据转换成 G/M/K/B的string
     * @param {Number} b 
     */
    static formatByte(b) {
        if (b > 1024 * 1024 * 1024) {
            return (b / (1024 * 1024 * 1024)).toFixed(1) + "G";
        } else if (b > 1024 * 1024) {
            return (b / (1024 * 1024)).toFixed(1) + "M";
        } else if (b > 1024) {
            return (b / (1024)).toFixed(1) + "K";
        } else {
            return b + '';
        }
    }

    static getPlayTimes(times) {
        if (times > 10000) {
            let ww = Math.floor(times / 10000);
            let bb = Math.ceil((times % 10000) / 100);
            if (bb < 10) {
                bb = '0' + bb;
            }
            return ww + "." + bb + "万次播放"
        }
        return times + "次播放"
    }

    static formatPlayTimes(times) {
        if (times > 10000) {
            let ww = Math.floor(times / 10000);
            let bb = Math.ceil((times % 10000) / 100);
            if (bb < 10) {
                bb = '0' + bb;
            }
            return ww + "." + bb
        }
        return times + ""
    }

    static formatScore(score) {
        return (score / 10).toFixed(1);
    }

    static isMovieExist(src, Movieid) {
        for (let i = 0; i < src.length; i++) {
            if (src[i].Movieid === Movieid) {
                return true;
            }
        }
        return false;
    }

    static removeMovie(src, Movieid) {
        for (let i = 0; i < src.length; i++) {
            if (src[i].Movieid === Movieid) {
                src.splice(i, 1);
            }
        }
        return src;
    }

    static getSubString(str, len) {
        if (str.length <= len) {
            return str;
        }
        return str.substring(0, len) + '...';
    }

    static md5(str) {
        var md = Forge.md.md5.create();
        md.update(str);
        return md.digest().toHex();
    }

    static randomTo(from, to) {
        if (from == to) return from;
        let rd = Math.round(Math.random() * 10);
        return from + (rd % (to - from));
    }

    static shuffle(a) {
        var len = a.length;
        for (var i = 0; i < len; i++) {
            var end = len - 1;
            var index = (Math.random() * (end + 1)) >> 0;
            var t = a[end];
            a[end] = a[index];
            a[index] = t;
        }
        return a;
    }

    static setStorageItem(key, value) { 
        return window.localStorage.setItem(key, value);
    }

    static getStorageItem(key) {
        return window.localStorage.getItem(key);
    }

    static getStorageInt(key, def = 0) {
        let value = Number(window.localStorage.getItem(key));
        if (!value || isNaN(value)) {
            return def;
        }
        return value;
    }

    static removeStorageItem(key) {
        return window.localStorage.removeItem(key);
    }

    static setStorageObj(key, value) {
        return window.localStorage.setItem(key, JSON.stringify(value));
    }

    static getStorageObj(key) {
        let str = AppUtils.getStorageItem(key);
        try {
            let obj = JSON.parse(str);
            return obj;
        } catch (error) {

        }
        return null;
    }

    static getQueryVariable(variable) {
        if (window.location.search && window.location.search != "") {
            var query = window.location.search.substring(1);
            if (query.indexOf("?") != -1) {
                query = query.substr(query.indexOf("?") + 1);
            }

            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
        }
        if (window.location.hash && window.location.hash != "") {
            var query = window.location.hash.substring(1);
            if (query.indexOf("?") != -1) {
                query = query.substr(query.indexOf("?") + 1);
            }

            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
        }
        return null;
    }



    static getUniqueID() {
        let uniqueid = AppUtils.getQueryVariable("deviceid");
        if (uniqueid == null || uniqueid == undefined || uniqueid == '' || uniqueid.length < 3) {
            uniqueid = AppUtils.getStorageItem('DEVICE_ID');
            if (uniqueid == null || uniqueid == undefined || uniqueid == '' || uniqueid.length < 3) {
                let timestamp = Date.parse(new Date());
                let randNum1 = AppUtils.randomTo(0, 1000000000);
                let randNum2 = AppUtils.randomTo(0, 1000000000);
                let randNum3 = AppUtils.randomTo(0, 1000000000);
                uniqueid = AppUtils.md5(timestamp + '' + randNum1 + '' + randNum2 + '' + randNum3);
            }
            AppUtils.setStorageItem('DEVICE_ID', uniqueid);
        }
        return uniqueid;
    }

    static setUniqueID(deviceId) {
        AppUtils.setStorageItem('DEVICE_ID', deviceId);
    }

    static maskPhoneNum(num) {
        if (num.length < 11) {
            return num;
        }
        var prev = num.substr(0, 3);
        var end = num.substr(7);
        return prev + "****" + end;
    }

    static YMPush(page, event) {
        window.YMPush('_trackEvent', page, event);
    }
}